// ProductCard.jsx
import React, { } from 'react';
import { useNavigate } from "react-router-dom";
import '../../Css/cardHome.css'
import { useStateValue } from  "../../Middleware/context/StateProvider";

export default function ProductCard({ 
  id, 
  nameProduto,
   idSupplier,
   taxa,
   destinoVenda,
   color,
   subtype,
   tipo, 
  fornecedor, 
  price, 
  img, 
  whatsapp,
  Data,
  status,
  transportadora,
  size
}) {
  const navigate = useNavigate();
    const { dispatch } = useStateValue();
  const data =new Date().toLocaleDateString()


  const openDetails = () => {
   navigate(`/Details/${tipo}/${subtype}/${id}`);
  };

  const openWhatsapp = () => {
    window.open(`https://wa.me/${whatsapp? whatsapp:'+244991660829'}`, "_blank");
  };

  const addToCart = () => {
    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        id,
       nameProduto,
        price,
        img,
        fornecedor,
        status:"Pending",
        Data:data,
        taxa,
        idSupplier,
        transportadora,
        destinoVenda,
        size,
        quantity:1,
      }
    });
  
  }
  return (
    <article className="product-card">
      <div className="product-image" onClick={openDetails}>
        <img src={img} alt={nameProduto} />
      </div>

      <div className="product-info">
        <h3>{nameProduto}</h3>
        <p className="supplier">{fornecedor}</p>
        <strong className="price">Kz {price +taxa}</strong>
      </div>

      <div className="product-actions">
        <button className="btn-buy"  onClick={addToCart} >Adicionar no Carrinho</button>
        <button className="btn-whatsapp" onClick={openWhatsapp}>WhatsApp</button>
      </div>
    </article>
  );
}